// test1432
(1432 && 0);
